import { asyncContextDependencies, contexts } from "../../util/async";
import { createDeveloperContext } from "./context";

export function initDeveloperContext() {
  const context = createDeveloperContext();
  asyncContextDependencies.developer.forEach((dep) => dep(context));
  contexts.developer = context;
  return context;
}
